var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShopUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0352 37.4004V52.3671C10.0352 67.3337 16.0352 73.3337 31.0018 73.3337H48.9685C63.9352 73.3337 69.9352 67.3337 69.9352 52.3671V37.4004",
    stroke: "#0094D9",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.999 40.0003C46.099 40.0003 50.599 35.0337 49.999 28.9337L47.799 6.66699H32.2323L29.999 28.9337C29.399 35.0337 33.899 40.0003 39.999 40.0003Z",
    stroke: "#0094D9",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0346 40.0003C67.768 40.0003 72.7013 34.5337 72.0346 27.8337L71.1013 18.667C69.9013 10.0003 66.568 6.66699 57.8346 6.66699H47.668L50.0013 30.0337C50.568 35.5337 55.5346 40.0003 61.0346 40.0003Z",
    stroke: "#0094D9",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7986 40.0003C24.2986 40.0003 29.2653 35.5337 29.7986 30.0337L30.532 22.667L32.132 6.66699H21.9653C13.232 6.66699 9.89863 10.0003 8.69863 18.667L7.79863 27.8337C7.13197 34.5337 12.0653 40.0003 18.7986 40.0003Z",
    stroke: "#0094D9",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0013 56.667C34.4346 56.667 31.668 59.4337 31.668 65.0003V73.3337H48.3346V65.0003C48.3346 59.4337 45.568 56.667 40.0013 56.667Z",
    stroke: "#0094D9",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopUploadIcon);
export default __webpack_public_path__ + "static/media/shop-upload-icon.b457c9b0de2e70b3c01a2d401bf6e6f0.svg";
export { ForwardRef as ReactComponent };